<!--用户下拉选择器  merge-button-->
<template>
  <el-dropdown>
    <el-link
      type="success"
      :underline="false"
      class="el-dropdown-link"
      @click="childMethod"
      >合并</el-link
    >
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="child in customerChild" :key="child.id">
        <i class="el-icon-s-custom"></i>
        <router-link
          target="_blank"
          :to="{ path: '/customers/view', query: { id: child.id } }"
          >{{ child.name }}({{ child.type_name }})</router-link
        >
        <i
          v-if="Acs('/customers/cancel-merge') && routePath == '/customers/index'"
          class="el-icon-circle-close"
          style="margin-left: 10px"
          @click="cancelMergeDialog(child)"
        >
        </i>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>


<script>
import CustomerService from "~/services/customer";

export default {
  name: "CustomerChild",
  props: {
    customerId: 0,
    masterName: "", //主客户名称
    routePath: "",
  },
  data() {
    return {
      //定义变量
      loading: true,
      customerChild: [],
    };
  },

  created: function () {
    /** 如果加载了这个组件，应当进行初始化操作 */
    // this.childMethod();
  },
  methods: {
    //远程搜索el-select远程获取方法。
    childMethod() {
      if (this.customerChild && this.customerChild.length > 0) return true;
      this.getChildList();
    },
    getChildList() {
      this.loading = true;
      setTimeout(() => {
        let params = {
          fields: "id,name,type_name",
          id: this.customerId,
        };
        CustomerService.getChild(params).then((res) => {
          this.loading = false;
          if (res.data) {
            this.customerChild = res.data;
          } else {
            this.customerChild = [];
          }
        });
        this.loading = false;
      }, 200);
    },
    //取消合并提示和数据处理。
    cancelMergeDialog(customer) {
      this.$confirm(
        "确定要解除与【" + this.masterName + "】的合并吗？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.cancelMerge(customer);
        })
        .catch(() => {});
    },

    //解除合并
    cancelMerge(customer) {
      CustomerService.cancelMerge(customer.id).then((res) => {
        if (res.code == 0) {
          //刷新数据
          this.resp_alert(res, "解除成功", (res) => {
            this.customerChild = this.customerChild.filter((item) => {
              return customer.id != item.id;
            });
          });
          //触发列表刷新
          this.$emit("cancelMerge", customer);
        } else {
          this.$message({
            message: "删除失败：" + res.msg,
            type: "error",
          });
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/widgets/CustomerChild.vue